// extracted by mini-css-extract-plugin
module.exports = {"iconArrow":"iconArrow_1Ug_p","slideArrow":"slideArrow_iu5rK","iconArrowFast":"iconArrowFast_1M1iy","slideArrowFast":"slideArrowFast_1Cubm","loadingEffect":"loadingEffect_Bob7z"};